import {
  Button,
  FormControl,
  FormLabel,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { UserInterestPayload } from "../../../api/UserInterestApi.ts";

interface MalpracticeInsuranceProps {
  onMalpracticeChange: (val: boolean | null) => void;
  formData: UserInterestPayload;
}

const MalpracticeInsurance: React.FC<MalpracticeInsuranceProps> = ({
  formData,
  onMalpracticeChange,
}) => {
  return (
    <FormControl maxW="368" alignSelf="center" isRequired>
      <FormLabel color="gray.500" fontSize="12px" fontWeight="700">
        Do you have your own malpractice insurance?
      </FormLabel>

      <Menu>
        <MenuButton
          as={Button}
          rightIcon={<ChevronDownIcon color="gray.500" />}
          variant="outline"
          height={14}
          w="full"
          borderColor="gray.300"
          textAlign="left"
          color={formData.hasMalpracticeInsurance === null ? "gray.400" : "gray.600"}
          fontWeight="400"
          _hover={{ borderColor: "gray.400" }}
        >
          {formData.hasMalpracticeInsurance === null
            ? "Select an option"
            : formData.hasMalpracticeInsurance
              ? "Yes"
              : "No"}
        </MenuButton>

        <MenuList>
          <MenuItem onClick={() => onMalpracticeChange(true)} _hover={{ bg: "gray.100" }}>
            Yes
          </MenuItem>
          <MenuItem onClick={() => onMalpracticeChange(false)} _hover={{ bg: "gray.100" }}>
            No
          </MenuItem>
        </MenuList>
      </Menu>
    </FormControl>
  );
};

export default MalpracticeInsurance;
